export default "__VITE_ASSET__BMi0sQig__"